<template>
  <div>
     <a href='#' @click.prevent="show = !show" class="ms-2 previous-note-link">{{ caret }}
      This version completed {{ notes.length }} {{ notes.length == 1 ? "note" : "notes" }}
    </a>
     <ul class="mix-previous-notes" v-show="show">
      <li v-for="note in notes" :key="note.id">
        <note-text :note-content="note.note" @time-click="onTimeClick" />
      </li>
     </ul>
  </div>
</template>
<style scoped>
ul.mix-previous-notes {
  list-style-position: inside;
  margin-left: -7px;
}

ul.mix-previous-notes li {
  list-style-type: '✅ ';
  font-size: 14px;
  margin-top: 3px;
}

ul.mix-previous-notes li:before {
  content: "";
  margin-left: 0;
}

.previous-note-link {
  color: #004c00;
  text-decoration: none;
}

</style>

<script>
import NoteText from "./note_text.vue"

export default {
  props: ["notes"],
  components: { NoteText },
  data: function() {
    return { show: false }
  },
  methods: {
    onTimeClick(numericTime) {
      this.$emit("play-at-time", numericTime)
    }
  },
  computed: {
    caret() {
      return this.show ? '▼' : '▶'
    }
  }
}
</script>
